import {
  IsNotEmpty, IsOptional,
} from "class-validator";

export class CreateCheckoutSessionDto {
  @IsNotEmpty()
  user_id: string;

  @IsNotEmpty()
  tariff_plan_id: string;

  @IsNotEmpty()
  price_id: string;

  @IsNotEmpty()
  title_trackers: string;

  @IsOptional()
  return_url?: string;

  @IsOptional()
  trial_days?: number;

  @IsOptional()
  club_id?: string;
}
